var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('temporary-items-table',{attrs:{"exclude-columns":['archived_at', 'message'],"exclude-actions":['activate']}}),_c('archive-message-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }